// Shared wording for decks (study-decks), so the Decks page, the Review
// chips and the card forms describe a deck the same way.

// An armed "Delete it?" disarms itself after this long.
export const DELETE_DISARM_MS = 5000;

const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

/** "12 cards · 3 due" — or "Empty" for a deck with no cards. */
export const deckCounts = (deck) => {
  const cards = deck?.card_count ?? 0;
  if (cards === 0) return "Empty";
  const due = deck?.due_count ?? 0;
  return `${plural(cards, "card")} · ${due > 0 ? `${due} due` : "none due"}`;
};
